module.exports = require("wrong-module");


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-module2/index.js
 ** module id = 2
 ** module chunks = 0
 **/